import React from 'react';

const BlogTitleProperties = ({ seminar, onSave }) => {
    const fonts = ['Lato', 'Roboto', 'Montserrat', 'Open Sans', 'Poppins'];
    const style = seminar.blogTitleStyle || {};

    const onUpdate = (newStyle) => {
        const updatedSeminar = {
            ...seminar,
            blogTitleStyle: { ...(seminar.blogTitleStyle || {}), ...newStyle }
        };
        onSave(updatedSeminar);
    };

    return (
        <div className="space-y-4">
            <p className="text-sm text-gray-600">Modifiez le style du titre de votre blog.</p>
            <div>
                <label className="block text-sm font-medium">Police</label>
                <select value={style.fontFamily || 'Lato'} onChange={(e) => onUpdate({ fontFamily: e.target.value })} className="w-full p-2 border rounded">
                    {fonts.map(font => <option key={font} value={font}>{font}</option>)}
                </select>
            </div>
            <div>
                <label className="block text-sm font-medium">Taille ({style.fontSize || 24}px)</label>
                <input type="range" min="16" max="48" value={style.fontSize || 24} onChange={(e) => onUpdate({ fontSize: parseInt(e.target.value) })} className="w-full" />
            </div>
            <div>
                <label className="block text-sm font-medium">Couleur du texte</label>
                <input type="color" value={style.color || '#000000'} onChange={(e) => onUpdate({ color: e.target.value })} className="w-full h-8" />
            </div>
            <div>
                <label className="block text-sm font-medium">Alignement</label>
                <div className="flex items-center gap-1 mt-1 rounded-md border p-1">
                    <button onClick={() => onUpdate({ textAlign: 'left' })} className={`p-2 w-full rounded ${(style.textAlign === 'left' || !style.textAlign) ? 'bg-blue-500 text-white' : 'bg-white hover:bg-gray-100'}`}><svg className="w-5 h-5 mx-auto" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd"></path></svg></button>
                    <button onClick={() => onUpdate({ textAlign: 'center' })} className={`p-2 w-full rounded ${style.textAlign === 'center' ? 'bg-blue-500 text-white' : 'bg-white hover:bg-gray-100'}`}><svg className="w-5 h-5 mx-auto" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd"></path></svg></button>
                    <button onClick={() => onUpdate({ textAlign: 'right' })} className={`p-2 w-full rounded ${style.textAlign === 'right' ? 'bg-blue-500 text-white' : 'bg-white hover:bg-gray-100'}`}><svg className="w-5 h-5 mx-auto" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 10a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd"></path></svg></button>
                </div>
            </div>
            <div className="pt-4 border-t">
                <label className="block text-sm font-medium">Couleur de fond</label>
                <input type="color" value={style.backgroundColor || '#FFFFFF'} onChange={(e) => onUpdate({ backgroundColor: e.target.value })} className="w-full h-8 mt-1" />
            </div>
            <div>
                <label className="block text-sm font-medium">Marge haute ({style.paddingTop || 0}px)</label>
                <input type="range" min="0" max="64" value={style.paddingTop || 0} onChange={(e) => onUpdate({ paddingTop: parseInt(e.target.value) })} className="w-full" />
            </div>
            <div>
                <label className="block text-sm font-medium">Marge basse ({style.paddingBottom || 0}px)</label>
                <input type="range" min="0" max="64" value={style.paddingBottom || 0} onChange={(e) => onUpdate({ paddingBottom: parseInt(e.target.value) })} className="w-full" />
            </div>
        </div>
    );
};

export default BlogTitleProperties;